import api from './axiosInstance';

export const NOTIFICATION_AUDIENCE = 'admin';

const withAudience = (params = {}) => ({ audience: NOTIFICATION_AUDIENCE, ...params });

const unwrap = (body) => body?.data ?? body;

export const fetchNotifications = (params = {}) =>
  api.get('/notifications', { params: withAudience(params) }).then(unwrap);

export const fetchUnreadCount = () =>
  api.get('/notifications/unread-count', { params: withAudience() }).then(unwrap);

export const fetchNotification = (id) =>
  api.get(`/notifications/${id}`, { params: withAudience() }).then(unwrap);

export const markNotificationRead = (id) =>
  api.patch(`/notifications/${id}/read`, null, { params: withAudience() }).then(unwrap);

export const markNotificationUnread = (id) =>
  api.patch(`/notifications/${id}/unread`, null, { params: withAudience() }).then(unwrap);

export const markAllNotificationsRead = (category) =>
  api
    .patch('/notifications/read-all', null, {
      params: withAudience(category ? { category } : {}),
    })
    .then(unwrap);

export const deleteNotification = (id) =>
  api.delete(`/notifications/${id}`, { params: withAudience() }).then(unwrap);

export const clearReadNotifications = () =>
  api.delete('/notifications', { params: withAudience({ status: 'read' }) }).then(unwrap);

export const fetchNotificationPreferences = () =>
  api.get('/notifications/preferences', { params: withAudience() }).then(unwrap);

export const updateNotificationPreferences = (preferences) =>
  api.put('/notifications/preferences', preferences, { params: withAudience() }).then(unwrap);

export const fetchPushPublicKey = () =>
  api.get('/notifications/push/public-key', { params: withAudience() }).then(unwrap);

export const savePushSubscription = (subscription) =>
  api
    .post('/notifications/push/subscribe', { subscription }, { params: withAudience() })
    .then(unwrap);

export const removePushSubscription = (endpoint) =>
  api
    .post('/notifications/push/unsubscribe', { endpoint }, { params: withAudience() })
    .then(unwrap);

export const sendTestNotification = () =>
  api.post('/notifications/test', {}, { params: withAudience() }).then(unwrap);
